import React from "react";
import { Box, Stack } from "@mui/joy";
import useAppSettings from "../../../contexts/app/appSettings";
import { Permission, usePermissions } from "../../../contexts/app/permissions";
import CommunicationSettingsSection from "./display/CommunicationSettingsSection";

export default function CommunicationSettingsPage() {
  const { config, reloadConfig } = useAppSettings();
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission(Permission.COMMUNICATION_SETTINGS_EDIT);

  React.useEffect(() => {
    if (!config) void reloadConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!config) return null;

  return (
    <Box sx={{ width: "100%", padding: 2, overflowY: "auto", height: "100%", maxHeight: "100%" }}>
      <Stack spacing={2} sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
        <CommunicationSettingsSection config={config} canEditBackend={canEdit} />
      </Stack>
    </Box>
  );
}
